import {AUTHORIZE, UNAUTHORIZE, SET_TWO_STEP_AUTHORIZATION_DATA} from '../actionTypes';

export const setAuthorizationData = authorizationData => ({type: AUTHORIZE, ...authorizationData});

export const removeAuthorizationData = () => ({type: UNAUTHORIZE});

export const setTwoStepAuthorizationData = twoStepAuthorizationData => ({type: SET_TWO_STEP_AUTHORIZATION_DATA, ...twoStepAuthorizationData});
